import Marquee from "react-fast-marquee";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/business";

export const Testimonials = () => {
  return (
    <section id="reviews" data-testid="testimonials-section" className="border-t border-[#222222] py-24 md:py-32">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 flex items-end justify-between mb-14 md:mb-20">
        <h2 className="font-display font-bold uppercase tracking-tight text-white text-4xl md:text-6xl lg:text-7xl leading-[0.9]">
          Happy
          <br />
          Customers
        </h2>
        <span className="text-xs uppercase tracking-[0.2em] text-[#FF3B30] font-mono-plex font-bold hidden md:block">
          [ 04 — Word of mouth ]
        </span>
      </div>

      <Marquee pauseOnHover speed={40} gradient={false}>
        {TESTIMONIALS.map((t, i) => (
          <div
            key={t.name}
            data-testid={`testimonial-card-${i}`}
            className="w-[340px] md:w-[420px] mx-2 md:mx-3 border border-[#222222] bg-[#0A0A0A] p-7 md:p-8 flex flex-col justify-between min-h-[230px]"
          >
            <div>
              <Quote className="w-5 h-5 text-[#FF3B30] mb-5" />
              <p className="text-[#CCCCCC] font-mono-plex text-sm leading-relaxed">{t.quote}</p>
            </div>
            <div className="mt-6 flex items-center gap-3">
              <span className="w-2 h-2 bg-[#FF3B30]" />
              <span className="font-mono-plex text-white uppercase tracking-[0.15em] text-xs">
                {t.name} — {t.area}
              </span>
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default Testimonials;
